import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { scrollToHashAnchor } from "../../helpers/scrollToAnchor";

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (hash: string) => (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (location.pathname === "/") {
      scrollToHashAnchor(hash);
    } else {
      // Navigate to home page with hash
      navigate(`/${hash}`);
    }
  };

  return (
    <footer>
      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <div className="footer-updated text-md-start">

                <div className="follow-us-links">
                  <h2>Follow Us</h2>
                  <div className="social-icons">
                    <a href="https://www.pinterest.com/webs2pdf/" target="_blank" rel="noopener noreferrer" aria-label="Webs2PDF on Pinterest">
                      <i className="fa-brands fa-pinterest" aria-hidden="true"></i>
                    </a>
                    <a href="https://www.reddit.com/user/Webs2PDF/" target="_blank" rel="noopener noreferrer" aria-label="Webs2PDF on Reddit">
                      <i className="fa-brands fa-reddit" aria-hidden="true"></i>
                    </a>
                    <a href="https://github.com/webs2pdf" target="_blank" rel="noopener noreferrer" aria-label="Webs2PDF on GitHub">
                      <i className="fa-brands fa-github" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>

                <div className="anchor-sections">
                  <ul>
                    <li>
                      <a href="/#contact" onClick={handleNavClick("#contact")}>About</a>
                    </li>
                    <li>
                      <a href="/#benefit" onClick={handleNavClick("#benefit")}>Benefits</a>
                    </li>
                    <li>
                      <a href="/#reviews" onClick={handleNavClick("#reviews")}>Reviews</a>
                    </li>
                    <li>
                      <a href="/#pricing" onClick={handleNavClick("#pricing")}>Pricing</a>
                    </li>
                    <li>
                      <a href="/#faq" onClick={handleNavClick("#faq")}>FAQ</a>
                    </li>
                    <li><a href="https://webs2pdf.com/blog/">Blog</a></li>
                    <li>
                      <a href="/#contact" onClick={handleNavClick("#contact")}>Contact</a>
                    </li>
                  </ul>

                  <p>Copyright © 2026 webs2pdf.com All rights reserved.</p>

                  <ul className="privacy-anchors">
                    <li>
                      <a href="/privacy-policy">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="/cookie-policy">Cookie Policy</a>
                    </li>
                    <li>
                      <a href="/terms-of-use">Terms of Use</a>
                    </li>
                    <li>
                      <a href="/return-and-refund-policy">Refund Policy</a>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
            <div className="col-md-5 text-md-end web-logo">
              <a href="/" className="f-logo">
                <img src="images/logo.svg" className="img-responsive" alt="Footer Logo" />
              </a>
            </div>
          </div>
          <div>
            <hr />
          </div>
          <div className="row justify-content-center align-items-center position-relative">
            <div className="col-md-6 text-md-start custom-footer mt-3 mt-md-0">
              <p>Transforming Web Content into Portable, Professional Documents</p>
            </div>

            <div className="col-md-6">
              <a href="#up" className="up-arrow">
                <img src="images/tick.png" width="70px" height="70px" className="img-responsive" alt="Up Arrow" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
